export const DEFAULT_SPHERE_GROUP_CODE = "improvement";
